import '../../styles/textStyle.css';
import './TitleBar.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var navigationWrapperCSS = '_11yg5w82-2-0-1';
export var subtitleCSS = '_11yg5w83-2-0-1 _3xlztp0-2-0-1 _3xlztp2-2-0-1 _3xlztp3-2-0-1 _3xlztpb-2-0-1';
export var suffixWrapperCSS = '_11yg5w84-2-0-1';
export var titleSubtitleWrapperCSS = _7a468({defaultClassName:'_11yg5w80-2-0-1',variantClassNames:{childrenAreText:{true:'_11yg5w81-2-0-1'}},defaultVariants:{},compoundVariants:[]});